// Section file — populated during component conversion.
// Sections: terms, privacy, refundPage, jobs, agent, common
import React from "react";

const lang = {
  terms: {
    title: "Terms Of Service",
    intro: (
      <>
        Thank you for choosing <span className="text-instagram">RizzUp</span> LLC, d/b/a <span className="text-instagram">ViralGPT</span> ("<span className="text-instagram">ViralGPT</span>", "we", "us", or "our") for your social media growth services. By accessing or using our website at <span className="text-instagram">viralgpt.com</span> (the "Site") or any of our services (the "Services"), you agree to be bound by the following Terms of Service (the "Agreement").
      </>
    ),
    serviceDescription: (
      <>
        <strong>Service Description:</strong> <span className="text-instagram">ViralGPT</span> is a website that provides social media growth services to help increase your followers, engagement, and overall presence on social media. Our Services include, but are not limited to, account management, growth strategies, and analytics.
      </>
    ),
    userConduct: (
      <>
        <strong>User Conduct:</strong> You agree to use the Site and Services in accordance with all applicable laws, rules, and regulations. You also agree not to engage in any of the following activities:
      </>
    ),
    conductList: [
      <>Violating any laws, rules, or regulations;</>,
      <>Impersonating any person or entity or falsely stating or otherwise misrepresenting your affiliation with a person or entity;</>,
      <>Interfering with or disrupting the Site or Services, or any servers or networks connected to the Site or Services;</>,
      <>Engaging in any activity that could harm or cause damage to <span className="text-instagram">ViralGPT</span>, the Site, the Services, or any other users;</>,
      <>Posting or transmitting any content that is illegal, harmful, threatening, abusive, harassing, defamatory, obscene, hateful, or otherwise objectionable;</>,
      <>Using any automated means, including without limitation, bots, spiders, or scrapers, to access the Site or Services;</>,
      <>Misrepresenting the nature or content of any information, products, or services provided by <span className="text-instagram">ViralGPT</span>.</>,
    ],
    payment: (
      <>
        <strong>Payment and Billing:</strong> By purchasing our Services, you agree to pay all fees associated with your account in a timely manner. <span className="text-instagram">ViralGPT</span> reserves the right to modify our pricing and billing practices at any time. All fees are non-refundable, and <span className="text-instagram">ViralGPT</span> reserves the right to suspend or terminate your account at any time for any reason.
      </>
    ),
    ip: (
      <>
        <strong>Intellectual Property:</strong> All content on the Site and Services, including without limitation, text, graphics, logos, images, software, and code, is the property of <span className="text-instagram">ViralGPT</span> and is protected by United States and international copyright and trademark laws. You may not copy, reproduce, distribute, or create derivative works based on any of the content without the prior written consent of <span className="text-instagram">ViralGPT</span>.
      </>
    ),
    warranties: (
      <>
        <strong>Disclaimer of Warranties:</strong> THE SITE AND SERVICES ARE PROVIDED "AS IS" AND WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. <span className="text-instagram">ViralGPT</span> DOES NOT WARRANT THAT THE SITE OR SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SITE OR SERVERS THAT MAKE THE SITE AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </>
    ),
    liability: (
      <>
        <strong>Limitation of Liability:</strong> <span className="text-instagram">ViralGPT</span> WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES (EVEN IF <span className="text-instagram">ViralGPT</span> HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM YOUR USE OF THE SITE OR SERVICES.
      </>
    ),
    indemnification: (
      <>
        <strong>Indemnification:</strong> You agree to defend, indemnify, and hold harmless <span className="text-instagram">ViralGPT</span>, its affiliates, and their respective directors, officers, employees, and agents from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees) arising from your use of the Site or Services, your violation of these Terms of Service, or your violation of any third-party rights.
      </>
    ),
    cancellation: (
      <>
        <strong>Cancellation Policy:</strong> You may cancel your subscription at any time by contacting us at <span className="text-instagram">support@viralgpt.com</span>. Cancellations will be effective at the end of the current billing cycle. No refunds will be given for any unused portion of your subscription.
      </>
    ),
    refundPolicy: (
      <>
        <strong>Refund Policy:</strong> We offer a 7-day money-back guarantee for our Services. If you are not satisfied with our Services within the first 7 days of your subscription, you may request a full refund by contacting us at <span className="text-instagram">support@viralgpt.com</span>. Refunds will be processed within 7 business days.
      </>
    ),
    contact: (
      <>
        <strong>Contact Information:</strong> If you have any questions or concerns regarding these Terms of Service, please contact us at <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    agreement: (
      <>
        By using the Site or Services, you agree to these Terms of Service. If you do not agree to these Terms of Service, you may not use the Site or Services. We reserve the right to modify these Terms of Service at any time, and such modifications will be effective immediately upon posting on the Site. Your continued use of the Site or Services after any modifications to these Terms of Service will constitute your acceptance of such modifications.
      </>
    ),
  },

  privacy: {
    title: "Privacy Policy",
    intro: (
      <>
        Thank you for choosing <span className="text-instagram">RizzUp</span> LLC, d/b/a <span className="text-instagram">ViralGPT</span> ("<span className="text-instagram">ViralGPT</span>", "we", "us", or "our") for your social media growth services. Protecting your privacy is important to us. This Privacy Policy explains how we collect, use, and disclose your personal information.
      </>
    ),
    infoCollect: (
      <>
        <strong>Information We Collect:</strong> We collect personal information that you provide to us when you create an account, purchase our Services, or communicate with us. This may include your name, email address, billing address, and payment information. We also collect non-personal information such as your IP address, browser type, and operating system when you visit our Site or use our Services.
      </>
    ),
    howWeUse: (
      <>
        <strong>How We Use Your Information:</strong> We use your personal information to provide you with our Services, process your payments, communicate with you about your account, and send you promotional materials. We also use non-personal information to analyze usage patterns on our Site and improve our Services.
      </>
    ),
    sharing: (
      <>
        <strong>Sharing Your Information:</strong> We do not sell, trade, or rent your personal information to third parties. We may disclose your personal information to our trusted service providers who assist us in providing our Services, such as payment processors and email providers. We require these service providers to protect your personal information and only use it for the purposes for which it was disclosed. We may also disclose your personal information if required by law or in response to a court order, subpoena, or other legal process.
      </>
    ),
    retention: (
      <>
        <strong>Data Retention:</strong> We retain your personal information for as long as necessary to provide you with our Services and for as long as required by law.
      </>
    ),
    security: (
      <>
        <strong>Security:</strong> We take reasonable measures to protect your personal information from unauthorized access, disclosure, or alteration. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee the absolute security of your personal information.
      </>
    ),
    children: (
      <>
        <strong>Children's Privacy:</strong> Our Site and Services are not intended for children under the age of 13. We do not knowingly collect personal information from children under the age of 13. If you are a parent or guardian and believe that your child has provided us with personal information, please contact us at <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    changes: (
      <>
        <strong>Changes to this Privacy Policy:</strong> We may update this Privacy Policy from time to time. We will post the updated Privacy Policy on our Site and indicate the date of the last revision. Your continued use of our Site or Services after the updated Privacy Policy is posted will constitute your acceptance of the updated Privacy Policy.
      </>
    ),
    contact: (
      <>
        <strong>Contact Information:</strong> If you have any questions or concerns regarding this Privacy Policy, please contact us at <span className="text-instagram">support@viralgpt.com</span>.
      </>
    ),
    agreement: (
      <>
        By using our Site or Services, you agree to this Privacy Policy. If you do not agree to this Privacy Policy, you may not use our Site or Services.
      </>
    ),
  },

  refundPage: {
    title: "Refund Policy",
    intro: (
      <>
        We offer a 7-day money-back guarantee for our Services. If you are not satisfied with our Services within the first 7 days of your purchase, you may request a full refund by contacting us at{" "}
        <span className="text-instagram">support@viralgpt.com</span>. Refunds will be processed within 7 business days.
      </>
    ),
    lookupTitle: "Transaction Lookup",
    emailPlaceholder: "Enter your email address",
    lookupOrders: "Lookup Orders",
    lookupFailed: "Failed to lookup transactions",
    requestError: "There was an error processing your request",
    historyTitle: "Transaction History",
    blockedBinNotice: (
      <>
        This payment method must be refunded manually. Please email <a href="mailto:support@viralgpt.com" className="link-blue">support@viralgpt.com</a> and our team will take care of you.
      </>
    ),
    thDate: "Date",
    thType: "Type",
    thAmount: "Amount",
    thAction: "Action",
    txTypes: {
      initial: "Initial",
      recurring: "Recurring",
      refill: "Refill",
      upsell: "Upsell",
      invoice: "Invoice",
      "change-plan": "Plan Change",
      topup: "Balance Top-Up",
      spin: "Spins",
      subcharge: "Subscription",
    },
    requestRefund: "Request Refund",
    blockedBinTitle: "Email support@viralgpt.com to refund this card.",
    refillHint: "Missing followers? We'll refill them free —",
    refillLink: "request a refill",
    cancelHint: "Just want to stop billing? —",
    cancelLink: "cancel your subscription",
    reviewNote: "We'll review your refund request and eligibility for our 7-day money-back guarantee.",
    immediateAssistance: (
      <>
        For immediate assistance, contact us at <a href="mailto:support@viralgpt.com" className="link-blue">support@viralgpt.com</a>
      </>
    ),
    reasonLabel: "Reason for refund",
    selectReason: "Select a reason...",
    optAccidentalAnnual: "Accidentally purchased annual",
    optMissingFollowers: "Missing Followers",
    optOther: "Other",
    switchTitle: "Switch to Monthly Billing",
    switchDesc: (refundDiff, price, monthlyPrice, planLabel) => (
      <>
        We'll refund <strong>${refundDiff}</strong> (the difference between your ${price} annual charge and ${monthlyPrice}/month) and switch your <strong>{planLabel}</strong> plan to monthly billing.
      </>
    ),
    annualChargePaid: "Annual charge paid",
    newMonthlyRate: "New monthly rate",
    perMo: (p) => `$${p}/mo`,
    refundAmountLabel: "Refund amount",
    noOriginalTx: "Could not find original transaction.",
    switchSuccess: (refundAmount, newMonthlyPrice, dateStr) =>
      `Done! You've been refunded $${refundAmount} and switched to $${newMonthlyPrice}/month. Your next charge is ${dateStr}.`,
    somethingWrong: "Something went wrong. Please contact support@viralgpt.com.",
    processing: "Processing...",
    switchBtn: (refundDiff) => `Refund $${refundDiff} & Switch to Monthly`,
    refillFree: "We can refill your missing followers for free!",
    goToRefill: "Go to Refill Page",
    detailsLabel: "Please provide more details",
    detailsPlaceholder: "Please describe why you are requesting a refund",
    detailsHelp: "Please provide a detailed reason to help us process your request.",
    submitting: "Submitting...",
    submitRequest: "Submit Request",
    enterReason: "Please enter a reason for your refund request.",
    submitSuccess: "Refund request submitted successfully. We will process it within 24 hours.",
    submitError: "There was an error processing your refund request. Please try again or contact support.",
    subscriptionTitle: "Your Subscription",
    subPlanLabel: "Plan",
    subPriceLabel: "Price",
    subNextChargeLabel: "Next charge",
    intervalMonthly: "Monthly",
    intervalAnnual: "Annual",
    cancelSubscription: "Cancel Subscription",
    keepSubscription: "Keep Subscription",
    confirmCancel: "Cancel Subscription",
    canceling: "Canceling...",
    cancelWhy: "We're sorry to see you go. Let us know why you're canceling — we may be able to fix it.",
    cancelReasonLabel: "Reason for canceling",
    cancelOptPriceTooHigh: "Price is too high",
    cancelOptNotUsing: "Not using it enough",
    cancelDetailsPlaceholder: "Please tell us why you are canceling",
    cancelSelectReason: "Please select a reason for canceling.",
    cancelDetailsRequired: "Please tell us why you are canceling.",
    cancelAccessNote: (dateStr) => `You won't be charged again. Your plan and growth stay active until ${dateStr}.`,
    cancelAccessNoteNoDate: "You won't be charged again. Your plan stays active until the end of your current billing period.",
    cancelSuccess: (dateStr) => `Your subscription has been canceled. You won't be charged again, and you keep access until ${dateStr}.`,
    cancelSuccessNoDate: "Your subscription has been canceled. You won't be charged again.",
    alreadyCanceled: (dateStr) => `This subscription is already canceled. You keep access until ${dateStr}.`,
    alreadyCanceledNoDate: "This subscription is already canceled.",
    subProfileLabel: "Account",
    refillSubTitle: "Auto-Refill Subscription",
    refillSubPrice: (amount, days) => `$${amount} every ${days} days`,
    cancelAutoRefill: "Cancel Auto-Refill",
    cancelAutoRefillNote: "This stops the recurring auto-refill charge. Refills already delivered are unaffected.",
    autoRefillCanceled: "Your auto-refill subscription has been canceled. You won't be charged again.",
    autoRefillAlreadyCanceled: "This auto-refill subscription is already canceled. You won't be charged again.",
  },

  cancelPortal: {
    title: "Cancel Your Subscription",
    intro: "Enter the email on your account to find your subscriptions and cancel in one click. No login required.",
    lookupTitle: "Find Your Subscriptions",
    findSubscriptions: "Find My Subscriptions",
    nothingToCancel: "We couldn't find an active subscription for this email. If you believe this is a mistake, contact support@viralgpt.com.",
    refillHint: "Missing followers? We'll refill them free —",
    refillLink: "request a refill",
    refundHint: "Looking for a refund instead? —",
    refundLink: "open the refund form",
  },

  refillPortal: {
    title: "Refill Missing Followers",
    intro: "Dropped followers are refilled free. Enter the email on your account, scan your profile, and we'll top it back up.",
    lookupTitle: "Find Your Accounts",
    findAccounts: "Find My Accounts",
    noProfiles: "We couldn't find a linked social account for this email. Contact support@viralgpt.com and we'll help.",
    selectProfile: "Select the account to scan",
    chooseProfile: "Choose an account...",
    scanProfile: "Scan For Missing Followers",
    scanning: "Scanning...",
    scanResults: "Scan Results",
    scanFailed: "We couldn't scan this account right now. Please try again shortly.",
    requestFailed: "We couldn't submit your refill. Please try again or contact support@viralgpt.com.",
    expected: "Expected followers",
    current: "Current followers",
    missing: "Missing",
    requestRefill: (count) => `Refill ${count} Followers Free`,
    submitting: "Submitting...",
    noneMissing: (count) => `No missing followers — your account is at ${count} followers, at or above what we delivered.`,
    claimed: "Your refill is on the way. Followers are typically restored within 24 hours.",
    deliveredTitle: "We Delivered On Our Promise",
    summaryTitle: "Your Account",
    stillDelivering: "Still being delivered",
    inFlightNote: (count) => `Your order is on its way — ${count} followers are still being delivered. Most orders finish within 24 hours.`,
    startedWith: "Followers when you started",
    youPurchased: "Followers you purchased",
    rightNow: "Followers right now",
    deliveredNote: (delivered, gained) => `We delivered ${delivered} followers to your account, and you're up ${gained} followers since you started with us. Nothing is missing — you're all set!`,
    deliveredNoteShort: (delivered, now) => `We delivered ${delivered} followers to your account, and you're sitting at ${now} followers today.`,
    helpNote: "Not what you expected? Send us a message and we'll make it right:",
    summaryNote: (now) => `Your account is at ${now} followers and everything looks healthy. We don't see a follower order on this account yet.`,
    shortfallNote: (count) => `Your count is about ${count} below what we delivered. Platforms remove inactive accounts over time — claim your free top-up below.`,
    settlingNote: (count) => `Your account is currently ${count} below what we delivered. Recent orders are still settling and platforms shed a few follows in the first days, so this usually resolves on its own — check back in a few days and we'll top you up free if it hasn't.`,
    limitNote: "Refills can be requested once every 24 hours per account.",
  },

  jobs: {
    greeting: "HI LISETTE",
    title: "JOBS",
    searchLabel: "Search for Jobs:",
    searchPlaceholder: "Enter job title or location",
    noJobs: "No jobs found.",
    loadFailed: "Failed to load jobs.",
    company: "Company:",
    location: "Location:",
    applyHere: "Apply Here",
    previous: "Previous",
    next: "Next",
    pageN: (n) => `Page ${n}`,
  },

  agent: {
    headerTitle: "CRO Agent",
    headerSubtitle: "ViralGPT Performance Intelligence",
    sendReport: "Send Report",
    reportSent: "Daily report sent to Discord!",
    reportFailed: (msg) => `Failed: ${msg}`,
    tabAgent: "Agent",
    tabData: "Data",
    readyTitle: "CRO Agent Ready",
    readyDesc: "I can query your database, browse your website with headless Chrome, access admin tools, and manage users/subscriptions (with your approval).",
    daysContext: (d) => `${d}D context`,
    analyzing: "Analyzing...",
    inputPlaceholder: "Ask about your funnel, ad spend, conversion rates...",
    agentUsedTools: (n) => `Agent used ${n} tool${n > 1 ? "s" : ""}:`,
    errorLabel: "Error:",
    requestFailed: "Request failed.",
    loadingData: "Loading data...",
    sections: {
      overview: "Overview",
      funnel: "Funnel",
      revenue: "Revenue",
      costs: "Costs & P/L",
      performance: "Performance",
    },
    viewLabels: {
      daily: "daily",
      weekly: "weekly",
      monthly: "monthly",
    },
    dateLabels: {
      daily: "Date",
      weekly: "Week",
      monthly: "Month",
    },
    cardLabels: {
      adSpend: "Ad Spend",
      grossRevenue: "Gross Revenue",
      netProfit: "Net Profit",
      roas: "ROAS",
      cpa: "CPA",
      cpc: "CPC",
      newSubs: "New Subs",
      lpToPurchase: "LP→Purchase",
      annualPct: "Annual %",
      views: "Views",
      addToCart: "Add to Cart",
      registrations: "Registrations",
      checkouts: "Checkouts",
      purchases: "Purchases",
      lpToAtc: "LP→ATC",
      atcToReg: "ATC→Reg",
      regToChk: "Reg→Chk",
      chkToPur: "Chk→Pur",
      lpToPur: "LP→Pur",
      initialRevenue: "Initial Revenue",
      recurringRevenue: "Recurring Revenue",
      topupRevenue: "Topup Revenue",
      annualPurchases: "Annual Purchases",
      monthlyPurchases: "Monthly Purchases",
      annualRatio: "Annual Ratio",
      subCosts: "Sub Costs (10%)",
      productCosts: "Product Costs (5%)",
      fees: "Fees (5%)",
      refunds: "Refunds (15%)",
      chargebacks: "Chargebacks (15%)",
      margin: "Margin",
    },
    tableHeaders: {
      overview: ["Spend", "Views", "Purch", "Gross", "Net", "ROAS", "CPA", "CPC", "LP→Pur", "Ann%"],
      funnel: ["Views", "ATC", "Reg", "Chkout", "Purch", "LP→ATC", "ATC→Reg", "Reg→Chk", "Chk→Pur", "LP→Pur"],
      revenue: ["Subs", "Initial", "Recurring", "Topup", "Gross", "Ann", "Mon", "Ann%", "ROAS"],
      costs: ["Spend", "Gross", "Sub 10%", "Prod 5%", "Fees 5%", "Refunds 15%", "CB 15%", "Net", "Margin"],
      performance: ["Spend", "Views", "Purch", "CPC", "CPA", "ROAS", "LP→ATC", "Chk→Pur", "LP→Pur"],
    },
    legendExceeds: "Exceeds benchmark",
    legendMeets: "Meets benchmark",
    legendBelow: "Below benchmark",
    resolved: "Resolved",
    requiresApproval: "Action Requires Approval",
    approve: "Approve",
    reject: "Reject",
    approvedResult: (r) => `Approved: ${r}`,
    rejected: "Rejected",
    errorResult: (m) => `Error: ${m}`,
    quickPrompts: {
      fullFunnelAudit: "Full Funnel Audit",
      annualVsMonthly: "Annual vs Monthly",
      cpcRoas: "CPC & ROAS",
      dailyTrends: "Daily Trends",
      scaleReadiness: "Scale Readiness",
      revenueLeaks: "Revenue Leaks",
      activeSubscribers: "Active Subscribers",
      cohortAnalysis: "Cohort Analysis",
    },
  },

  common: {
    cancel: "Cancel",
    loading: "Loading...",
  },
};

export default lang;
